import { makeStyles } from '@mui/styles';

import { AppointmentNote, BaseNote, NOTE_ACTIONS, StaffNote } from './Types';
import { NoteItem } from './NoteItem';
import { AppointmentNoteItem } from './AppointmentNoteItem';
import CardLoader from '@/components/CardLoader';

export interface NoteListProps {
  noteListData: BaseNote[];
  loading: boolean;
  actionCallback: (
    note: BaseNote,
    action: keyof typeof NOTE_ACTIONS,
    data?: any
  ) => void;
}

export const useStyles = makeStyles(() => ({
  root: {},
  loading: {
    marginTop: 60
  },
  noNotes: {
    margin: 'auto',
    marginTop: 6,
    paddingTop: 56,
    width: '100%',
    height: 140,
    backgroundColor: '#f5f5f5',
    color: '#999',
    borderRadius: 8,
    textAlign: 'center'
  }
}));

const NoteList = (props: NoteListProps) => {
  const { noteListData, actionCallback, loading } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {loading ? (
        <div className={classes.loading}>
          <CardLoader />
        </div>
      ) : (
        <>
          {noteListData.length === 0 && (
            <div className={classes.noNotes}>No notes to show</div>
          )}
          {noteListData.length > 0 &&
            noteListData.map((note, i) => {
              if (note.type === 'APPOINTMENT') {
                return (
                  <div key={i}>
                    <AppointmentNoteItem
                      note={note as AppointmentNote}
                      actionCallback={actionCallback}
                    />
                  </div>
                );
              } else if (note.type === 'CUSTOMER') {
                return (
                  <div key={i}>
                    <NoteItem
                      note={note as StaffNote}
                      actionCallback={actionCallback}
                    />
                  </div>
                );
              }
            })}
        </>
      )}
    </div>
  );
};

export default NoteList;
